import React from 'react';
import { useStore } from '@nanostores/react';
import * as _ from "lodash";

import NavBtnWidget from '../NavBtnWidget.jsx';

import {
    InputWidget, SingleSelectWidget, MultiSelectWidget,
    fromLabelValueCb, toLabelValueCb
} from '../../controls/widgets.jsx';

import * as C from "../../controls/constraints.jsx";

import { $stdHealthGroups, $isFirstPoDict, $additionalStatusTypes } from '../../stores/Dictionaries.jsx';


export default ({schema, data, onDataChanged}) => {
    const
        me = this,
        //
        onDataChangeEventHandler = (value, key) => {
            let diff = {};
            diff[key] = value;
            (onDataChanged || function(){})(diff);
        },
        //
        stdHealthGroups = useStore($stdHealthGroups),
        isFirstPoDict = useStore($isFirstPoDict),
        additionalStatusTypes = useStore($additionalStatusTypes);

        return (
            <form className="form">
                <div className="card borer-primary">
                    <div className="card-header text-bg-primary">Дополнительная информация</div>
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <SingleSelectWidget
                                    name="health_group"
                                    title="Медицинская группа по физической культуре:"
                                    options={stdHealthGroups}
                                    cbFromData={fromLabelValueCb}
                                    cbToData={toLabelValueCb}
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler.bind(me)}
                                    validators={[
                                        new C.NotEmptyConstraint("Укажите вашу медицинскую группу")
                                    ]}
                                />
                            </div>
                            <div className="col-md-12">
                                <SingleSelectWidget
                                    name="is_first_po"
                                    title="Профессиональное образование получаю:"
                                    options={isFirstPoDict}
                                    cbFromData={fromLabelValueCb}
                                    cbToData={toLabelValueCb}
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler.bind(me)}
                                    validators={[
                                        new C.NotEmptyConstraint("Заканчивали ли вы профессиональные образовательные учреждения?")
                                    ]}
                                />
                            </div>
                            <div className="col-md-12">
                                <MultiSelectWidget
                                    name="special_status"
                                    title="Особые статусы"
                                    options={additionalStatusTypes}
                                    cbFromData={fromLabelValueCb}
                                    cbToData={toLabelValueCb}
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler.bind(me)}
                                />
                            </div>
                            <div className="col-md-12">
                                <InputWidget
                                    type="textarea"
                                    name="additional_info"
                                    title="Дополнительная информация:"
                                    vertical={true}
                                    schema={schema}
                                    data={data}
                                    onChange={onDataChangeEventHandler.bind(me)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <NavBtnWidget to="/contacts" />

            </form>
        );
    }